<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-text-field label="Group Name" v-model="name"></v-text-field>
        </v-col>
        <v-col cols="6"
          ><v-text-field
            label="Description"
            v-model="description"
          ></v-text-field
        ></v-col>
      </v-row>
    </v-container>

    <v-container
      ><v-row>
        <v-col cols="4"></v-col
        ><v-col cols="4">
          <v-btn
            outlined
            rounded
            :color="getOutlineColor"
            large
            @click="createGroup()"
            >Create Group</v-btn
          ></v-col
        ><v-col cols="4"></v-col></v-row
    ></v-container>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data: () => ({
    name: null,
    description: null,
  }),
  methods: {
    createGroup() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-sms-group",
          {
            name: this.name,
            description: this.description,
          },
          this.getAccessToken
        )
        .then((group) => {
          if (group == "exist") {
            this.$emit("exist", "Group Exist");
          } else {
            this.$emit("group-created", group);
            this.$store.commit("setLoader", false);
          }
        });
    },
  },
};
</script>

<style></style>
